import "./Navbar.css";
import React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { useDispatch, useSelector } from "react-redux";
import { getMessagesData } from "features/message/messagesSlice";
import BrandLogo from "assets/images/flow-minder-logo- 2.png";
import ProfileMenu from "./ProfileMenu";
import useEffectHook from "utilities/hook/useEffectHook";

function Navbar() {
  // get user token from global state
  const { userInfo, userToken } = useSelector((state) => state.auth);
  const { totalUnreadMessage } = useSelector((state) => state.messages);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // get messages data
  const getDataStatistic = async() => {

    const payload = {
      "user_uid": userInfo?.uid
    };
    const request = await apiRequest({
        requestType: requestType.getTeacherStats,
        payload: {
            data: payload
        },
    })
    const response = await request?.data;
    if (response?.status === 0) {
      dispatch(getMessagesData(response.data.total_unreacted_messages));
    } 
  }

  useEffectHook(() => {
      // if user token undefined then redirect to login page
      if (!userToken) {
        navigate("/login");
      }

      // get data message 
      getDataStatistic();
    }, [], 0
  );

  return (
    <div className="w-full bg-custom-navy h-[100px] sticky">
      <div className="max-w-screen-lg mx-auto flex items-center justify-between h-full">
        <div className="flex items-center">
          <img src={BrandLogo} className="w-[173px] mr-[50px]" alt="" />
          <nav className="navbar">
            <ul className="list-none flex gap-[50px]">
              <li className="text-[22px] text-white font-medium">
                <NavLink to="/home">Dashboard</NavLink>
              </li>
              <li className="text-[22px] text-white font-medium">
                <NavLink to="/messages">
                  Messages 
                  {totalUnreadMessage > 0 && (<span className="notive">{totalUnreadMessage}</span>)}
                </NavLink>
              </li>
              <li className="text-[22px] text-white font-medium">
                <NavLink to="/mood-overview">Mood Overview</NavLink>
              </li>
              <li className="text-[22px] text-white font-medium">
                <NavLink to="/contact-us">Contact Us</NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <div className="h-7 w-7">
          <ProfileMenu />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
